import { useSelector } from 'react-redux'
import { Core as Type } from '../../../../../../types/Survey/Element'
import Textarea from '../../../../../UI/Textarea/Textarea'
import { Props } from './types'
import props from '../../../../../../redux/props'
import Input from '../../../../../UI/Input/Input'
import DirectFileUpload, { OnCallbackFile, UPLOAD_TYPES } from '../../../../../UI/DirectFileUpload/DirectFileUpload'
import { s3PublicStoragePrefix } from '../../../../../../utility'
import { TrashIcon } from '@heroicons/react/24/solid'

const Core: React.FC<Props<Type<any>>> = ({ element, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const set = (prop: keyof Type<any>) => (value: string) => {
    update({ ...element, [prop]: value })
  }

  const setInfoImage = (file: OnCallbackFile) => {
    update({ ...element, infoImageKey: file.key })
  }

  const removeInfoImage = () => {
    update({ ...element, infoImageKey: null })
  }

  return (
    <div>
      <div className="flex flex-row gap-2">
        <Input label={t.survey.configuration.generic.title} value={element.title} onChange={set('title')} />
        {/* <Input label={t.survey.configuration.generic.helpText} value={element.helpText} onChange={set('helpText')} /> */}
      </div>
      <Textarea label={t.survey.configuration.generic.description} value={element.description} onChange={set('description')} />
      <div className="flex flex-row gap-2">
        <div className="flex-1">
          <Textarea label={t.survey.configuration.generic.infoText} value={element.infoText} onChange={set('infoText')} />
        </div>
        <div className="flex gap-2 flex-1">
          <div className="shrink-0">
            <div className={'text-gray text-sm'}>{t.survey.configuration.generic.infoImage}</div>
            <DirectFileUpload
              maxFileSizeInBytes={5000000}
              uploadType={UPLOAD_TYPES.SURVEY_INFO_IMAGE}
              allowedMimeTypes={['image/*']}
              label={t.survey.configuration.generic.infoImage}
              onFilesCallback={setInfoImage}
              className="w-fit !py-0 h-fit"
              innerClassName="px-3 py-1 bg-blue text-white border-none "
            />
            {element.infoImageKey && (
              <div className="cursor-pointer mt-2" onClick={removeInfoImage}>
                <TrashIcon className="w-5 fill-gray hover:fill-red" />
              </div>
            )}
          </div>
          {element.infoImageKey && (
            <div className="flex py-3">
              <img
                src={`${s3PublicStoragePrefix}${element.infoImageKey}`}
                alt={element.title}
                className="h-[100px] object-cover w-full object-container py-3 bg-white"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Core
